import { Module } from '../Module';
import {
  GetUserSelectableSiteTimeZonesRequest,
  IGetUserSelectableSiteTimeZonesResult,
} from '../ServerApi/requests/GetUserSelectableSiteTimeZonesRequest';
import { ITimeZone } from '../ServerApi/types/ITimeZone';
import { ServerService } from '../services/ServerService';

export interface IGetSiteTimeZonesResult {
  fullTimeZonesList: ITimeZone[];
}

export class SiteTimeZones {

  public static $inject = ['ServerService'];

  constructor(private server: ServerService) { }

  public getAll(): ng.IPromise<IGetSiteTimeZonesResult> {
    return this.server.sendRequest(new GetUserSelectableSiteTimeZonesRequest())
      .then((result: IGetUserSelectableSiteTimeZonesResult) => {
        return {
          fullTimeZonesList: result.curatedTimeZonesList.concat(result.extraTimeZonesList).sort((tz1, tz2) => {
            if (tz1.timeZoneRawOffsetMinutes > tz2.timeZoneRawOffsetMinutes) {
              return 1;
            }
            if (tz1.timeZoneRawOffsetMinutes < tz2.timeZoneRawOffsetMinutes) {
              return -1;
            }
            return 0;
          })
        };
      });
  }
}

Module.instance().service('SiteTimeZones', SiteTimeZones);
